import { render, staticRenderFns } from "./full-width-video.vue?vue&type=template&id=432a8cbf&"
import script from "./full-width-video.vue?vue&type=script&lang=js&"
export * from "./full-width-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('432a8cbf')) {
      api.createRecord('432a8cbf', component.options)
    } else {
      api.reload('432a8cbf', component.options)
    }
    module.hot.accept("./full-width-video.vue?vue&type=template&id=432a8cbf&", function () {
      api.rerender('432a8cbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/full-width-video.vue"
export default component.exports